"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _lodash = _interopRequireDefault(require("lodash"));

var _vue = require("vue");

var _utils = require("../../utils");

var _checkMedia = require("../../utils/checkMedia");

var _types = require("../types");

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var _default = function _default(props, sheetMusicBusiness, loadObj, alertTips, initMediaMixer, destroyMediaMixer) {
  var recordDeviceOk = (0, _vue.ref)(false); //录音设备初始化情况

  var userDeviceOk = (0, _vue.ref)(true);
  var canShowPlayScore = (0, _vue.ref)(true);
  var playScoreParams = (0, _vue.reactive)({
    score: false,
    scoreType: 0,
    scorePart: 1,
    pitchBar: false,
    scoreLevel: '0' // 评分等级

  });
  var recordScore = (0, _vue.reactive)({
    totalScore: 0,
    pitchScore: 0,
    rhythmScore: 0 // 节奏

  });
  var isRecordScore = (0, _vue.ref)(false); // 正在录音评分

  var recordUserAudio = (0, _vue.ref)(undefined); //评分录音音频

  var recordAccAudio = (0, _vue.ref)(undefined); // 评分伴奏音频

  var recordResultAudio = (0, _vue.ref)(undefined); // 评分混音音频

  var recordReplayVisible = (0, _vue.ref)(false); //显示回放弹窗

  var recordResultVisible = (0, _vue.ref)(false); // 显示评分成绩结果弹窗

  var recordScoreResultRealTime = (0, _vue.ref)([]); // 评分实时分数数据

  var recordReplayJson = (0, _vue.ref)(''); // 评分纠错JSON文件

  var recordUploadData = (0, _vue.ref)({}); // 存放录音评分上传数据

  var playState = (0, _vue.ref)('');
  var playMode = (0, _vue.ref)('ori');
  var recordStartInfo = {
    speed: undefined,
    range: undefined
  };
  var recordEndInfo = {
    keySignature: '',
    speed: undefined,
    range: undefined,
    isPreReadyTime: true,
    timeIteratorParams: undefined,
    recordStartTime: 0,
    scoreType: 0,
    scorePart: 1,
    displayMode: 0
  };
  var recordStartTime = (0, _vue.ref)(0);
  var playEvents = (0, _vue.ref)({
    ON_SCORE_UPDATE: function ON_SCORE_UPDATE(_ref) {
      var score = _ref.score,
          pitchScore = _ref.pitchScore,
          rhythmScore = _ref.rhythmScore;
      recordScore.totalScore = score;
      recordScore.pitchScore = pitchScore;
      recordScore.rhythmScore = rhythmScore;
    },
    // 更新音高条
    ON_USER_PITCH: function ON_USER_PITCH(_ref2) {
      var start = _ref2.start,
          end = _ref2.end,
          pitch = _ref2.pitch,
          opitch = _ref2.opitch;
      var startTime = Math.round(start * 1000);
      var endTime = Math.round(end * 1000); // console.log('更新音高条', startTime, endTime, pitch, opitch);

      addUserPitch(startTime, endTime, pitch, opitch);
    }
  });

  var addUserPitch = function addUserPitch(start, end, pitch, opitch) {
    var _a;

    (_a = sheetMusicBusiness.value) === null || _a === void 0 ? void 0 : _a.plugin.$pitchBarRender.addUserPitch(start, end, pitch, opitch);
  };

  (0, _vue.watch)(function () {
    return playState.value;
  }, function (newVal) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!playScoreParams.score) {
                _context.next = 3;
                break;
              }

              _context.next = 3;
              return onPlayScoreChange(newVal);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  });
  (0, _vue.watch)(function () {
    return recordResultVisible.value;
  }, function () {
    if (!recordResultVisible.value) {
      resetRecordScore();
      destroyMediaMixer();
    }
  });
  (0, _vue.watch)(function () {
    return loadObj.loading;
  }, function () {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (playScoreParams.score) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
  });
  (0, _vue.watch)(function () {
    return playScoreParams.score;
  }, function (newVal) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!props.renderSheetOnly) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return");

            case 2:
              if (!newVal) {
                _context3.next = 9;
                break;
              }

              _context3.next = 5;
              return (0, _checkMedia.checkAudioDevice)();

            case 5:
              userDeviceOk.value = _context3.sent;

              if (!userDeviceOk.value) {
                playScoreParams.score = false;
                userDeviceOk.value = true;
                alertTips.showMessage('warning', '录音设备异常，请检查设备');
                setTimeout(function () {
                  alertTips.hideMessage();
                }, 1500);
              } else {
                canShowPlayScore.value;
              }

              _context3.next = 10;
              break;

            case 9:
              resetRecordScore();

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
  });

  var setIsRecordScoreing = function setIsRecordScoreing(state) {
    isRecordScore.value = state;
  };

  var checkSystem = function checkSystem() {
    var os = (0, _utils.getOs)();

    if (os) {
      switch (os) {
        case 'win32':
          console.log('【组件库】当前为win32环境');
          canShowPlayScore.value = false;
          break;

        case 'win64':
          console.log('【组件库】当前为win64环境');
          canShowPlayScore.value = true;
          break;

        case 'OS X':
          console.log('【组件库】当前为ios环境');
          canShowPlayScore.value = true;
          break;

        default:
          console.log('【组件库】当前环境不明');
          break;
      }
    } else {
      console.log('【组件库】当前环境不明');
    }
  }; // 初始化录音设备


  var initPlayScore = function initPlayScore() {
    return new Promise(function (resolve, reject) {
      var _a;

      (_a = sheetMusicBusiness.value) === null || _a === void 0 ? void 0 : _a.initRecorder({
        mp3WorkerPathPrefix: props === null || props === void 0 ? void 0 : props.workerPublicPath
      }, playEvents.value).then(function (result) {
        recordDeviceOk.value = result;

        if (!recordDeviceOk.value) {
          playScoreParams.score = false;
          destroyPlayScore();
          reject(new Error('init recorder failed'));
          return;
        }

        resolve();
      }).catch(function (e) {
        destroyPlayScore();
        reject(e);
      });
    });
  }; // 销毁录音评分实例


  var destroyPlayScore = function destroyPlayScore() {
    var _a, _b;

    ((_a = sheetMusicBusiness.value) === null || _a === void 0 ? void 0 : _a.recordScoreTool) && ((_b = sheetMusicBusiness.value) === null || _b === void 0 ? void 0 : _b.destroyRecorder());
  }; // Blob数据加上类型


  var getBlobWithType = function getBlobWithType(blob) {
    return new Promise(function (resolve, reject) {
      if (blob.type) {
        resolve(blob);
        return;
      }

      var reader = new FileReader();
      reader.readAsArrayBuffer(blob);

      reader.onload = function (e) {
        var _a;

        var arrayBuffer = ((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.result) || '';
        var newBlob = new Blob([arrayBuffer], {
          type: 'audio'
        });
        resolve(newBlob);
      };

      reader.onerror = function () {
        reject();
      };
    });
  };

  var changePlayScoreLoading = function changePlayScoreLoading(state, loadingTip) {
    if (state) {
      loadObj.loading = true;
      loadObj.loadingTip = loadingTip ? loadingTip : loadObj.loadingText;
    } else {
      loadObj.loading = false;
      loadObj.loadingTip = loadObj.loadingText;
    }
  }; // 播放前获取所需数据


  var getStartRecordInfo = function getStartRecordInfo(_playMode, _speed, _range) {
    playMode.value = _playMode;
    recordStartInfo.speed = _speed;
    recordStartInfo.range = _range;
  }; // 播放结束后获取所需数据


  var getEndRecordInfo = function getEndRecordInfo(_displayMode, _playMode, _speed, _keySignature, _isPreReadyTime, startTime, accAudio) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee4() {
      var accArrayBuffer;
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              recordEndInfo.speed = _speed;
              recordEndInfo.scoreType = playScoreParams.scoreType;
              recordEndInfo.scorePart = playScoreParams.scorePart;
              recordEndInfo.displayMode = _displayMode;
              recordEndInfo.range = recordStartInfo.range;
              recordEndInfo.keySignature = _keySignature;
              recordEndInfo.isPreReadyTime = _isPreReadyTime;
              recordEndInfo.timeIteratorParams = (0, _extends2.default)((0, _extends2.default)({}, _types.sheetTimeParamsMap[playMode.value]), {
                playBackSpeed: _speed
              });
              recordStartTime.value = startTime || 0;
              recordEndInfo.recordStartTime = startTime || 0;

              if (!(!recordReplayVisible.value && playScoreParams.score && (_playMode === _types.PlayMode.ori || _playMode === _types.PlayMode.acc) && accAudio)) {
                _context4.next = 23;
                break;
              }

              _context4.prev = 11;
              _context4.next = 14;
              return (0, _utils.fetchBuffer)(accAudio);

            case 14:
              accArrayBuffer = _context4.sent;
              _context4.next = 17;
              return getBlobWithType(new Blob([accArrayBuffer]));

            case 17:
              recordAccAudio.value = _context4.sent;
              _context4.next = 23;
              break;

            case 20:
              _context4.prev = 20;
              _context4.t0 = _context4["catch"](11);
              console.error('获取伴奏音频失败：', _context4.t0 === null || _context4.t0 === void 0 ? void 0 : _context4.t0.message);

            case 23:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[11, 20]]);
    }));
  }; // 设置当前播放状态


  var setPlayScorePlayState = function setPlayScorePlayState(state) {
    playState.value = state;
  };

  var onPlayScoreChange = function onPlayScoreChange(platState) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee5() {
      var _a, _b, _c, recordScoreTool, _recordScoreTool, _recordScoreTool2;

      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.t0 = platState;
              _context5.next = _context5.t0 === 'start' ? 3 : _context5.t0 === 'pause' ? 5 : _context5.t0 === 'continue' ? 8 : _context5.t0 === 'stop' ? 11 : 35;
              break;

            case 3:
              // 正常播放、点选播放、AB段播放
              try {
                isRecordScore.value = true;
              } catch (e) {
                console.error('录音设备创建失败:', e === null || e === void 0 ? void 0 : e.message);
              }

              return _context5.abrupt("break", 35);

            case 5:
              recordScoreTool = (_a = sheetMusicBusiness.value) === null || _a === void 0 ? void 0 : _a.recordScoreTool;
              recordScoreTool && recordScoreTool.pause();
              return _context5.abrupt("break", 35);

            case 8:
              _recordScoreTool = (_b = sheetMusicBusiness.value) === null || _b === void 0 ? void 0 : _b.recordScoreTool;
              _recordScoreTool && _recordScoreTool.continue();
              return _context5.abrupt("break", 35);

            case 11:
              _recordScoreTool2 = (_c = sheetMusicBusiness.value) === null || _c === void 0 ? void 0 : _c.recordScoreTool;

              if (!(_recordScoreTool2 && isRecordScore.value)) {
                _context5.next = 33;
                break;
              }

              _context5.prev = 13;
              loadObj.loading = true;
              loadObj.loadingTip = '正在生成评分结果...';
              _context5.next = 18;
              return _recordScoreTool2.stop();

            case 18:
              _context5.next = 20;
              return setRecordScore();

            case 20:
              _context5.next = 22;
              return initMediaMixer(recordUserAudio.value, recordAccAudio.value, recordStartTime.value);

            case 22:
              recordResultVisible.value = true;
              isRecordScore.value = false;
              _context5.next = 29;
              break;

            case 26:
              _context5.prev = 26;
              _context5.t1 = _context5["catch"](13);
              console.error("\u5F55\u97F3\u8BC4\u5206\u505C\u6B62\u51FA\u9519\uFF1A".concat(_context5.t1 === null || _context5.t1 === void 0 ? void 0 : _context5.t1.message));

            case 29:
              _context5.prev = 29;
              loadObj.loading = false;
              loadObj.loadingTip = loadObj.loadingText;
              return _context5.finish(29);

            case 33:
              destroyPlayScore();
              return _context5.abrupt("break", 35);

            case 35:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[13, 26, 29, 33]]);
    }));
  }; // 重置录音评分数据


  var resetRecordScore = function resetRecordScore() {
    recordScore.totalScore = 0;
    recordScore.pitchScore = 0;
    recordScore.rhythmScore = 0;
    recordUserAudio.value = undefined;
    recordAccAudio.value = undefined;
    recordReplayJson.value = '';
    recordResultAudio.value = undefined;
    recordReplayVisible.value = false;
    recordResultVisible.value = false;
    recordScoreResultRealTime.value = [];
    recordUploadData.value = {};
    recordEndInfo.keySignature = '';
    recordEndInfo.speed = undefined;
  }; // 播放结束后，整理录音评分数据


  var setRecordScore = function setRecordScore() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee6() {
      var _d, recordScoreTool, userAudio, partName, eurData;

      return _regenerator.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              recordScoreTool = (_d = sheetMusicBusiness.value) === null || _d === void 0 ? void 0 : _d.recordScoreTool;
              _context6.prev = 1;
              _context6.next = 4;
              return recordScoreTool.getMp3();

            case 4:
              userAudio = _context6.sent;
              _context6.next = 7;
              return getBlobWithType(userAudio);

            case 7:
              recordUserAudio.value = _context6.sent;
              partName = 'P' + playScoreParams.scorePart;
              _context6.next = 11;
              return recordScoreTool.getEur(partName);

            case 11:
              eurData = _context6.sent;
              recordScoreResultRealTime.value = eurData.rePlayScore;
              _context6.next = 15;
              return recordScoreTool.getReplayJson(partName);

            case 15:
              recordReplayJson.value = _context6.sent;
              recordUploadData.value = {
                score_file_url: props.song.evxmlFileUrl,
                score_file_md5: props.song.evxmlFileMd5,
                file_url: '',
                eur_file_url: eurData.eurXml,
                score_level: '0',
                countdown_num: '0',
                score_part: partName,
                song_id: props.song.id,
                instrument_id: playScoreParams.scoreType,
                score: recordScore.totalScore,
                song_name: props.song.name,
                tone: recordEndInfo.keySignature,
                speed: recordEndInfo.speed,
                is_need_interlude: playMode.value === _types.PlayMode.ori || playMode.value === _types.PlayMode.acc ? 1 : 0
              };
              _context6.next = 22;
              break;

            case 19:
              _context6.prev = 19;
              _context6.t0 = _context6["catch"](1);
              console.error('录音评分结束，获取结果有误:', _context6.t0 === null || _context6.t0 === void 0 ? void 0 : _context6.t0.message);

            case 22:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[1, 19]]);
    }));
  }; // 开启或关闭回放弹窗


  var openReplay = function openReplay(resultAudio) {
    recordReplayVisible.value = true;

    if (resultAudio) {
      recordResultAudio.value = resultAudio;
    }
  };

  var resetPlayScore = function resetPlayScore() {
    _lodash.default.merge(playScoreParams, {
      score: false,
      scoreType: 0,
      scorePart: 1,
      pitchBar: false,
      scoreLevel: '0'
    });
  }; // 监听预设参数变化，评分相关


  var onChangePreviewParams = _lodash.default.debounce(function (previewParams) {
    var _ref3 = (previewParams === null || previewParams === void 0 ? void 0 : previewParams.detail) || {},
        _playScoreParams = _ref3.playScoreParams;

    if (_playScoreParams) {// _.merge(playScoreParams, _playScoreParams);
    } else {
      resetPlayScore();
    }
  }, 200);

  (0, _vue.onMounted)(function () {
    checkSystem();
    window.addEventListener(_types.PreviewParamsEvent.CHANGE_PREVIEW_PARAMS, onChangePreviewParams);
  });
  (0, _vue.onBeforeUnmount)(function () {
    window.removeEventListener(_types.PreviewParamsEvent.CHANGE_PREVIEW_PARAMS, onChangePreviewParams);
  });
  return {
    recordDeviceOk: recordDeviceOk,
    userDeviceOk: userDeviceOk,
    isRecordScore: isRecordScore,
    playScoreParams: playScoreParams,
    recordScore: recordScore,
    recordUserAudio: recordUserAudio,
    recordAccAudio: recordAccAudio,
    recordResultAudio: recordResultAudio,
    recordReplayJson: recordReplayJson,
    recordReplayVisible: recordReplayVisible,
    recordResultVisible: recordResultVisible,
    recordScoreResultRealTime: recordScoreResultRealTime,
    recordUploadData: recordUploadData,
    recordEndInfo: recordEndInfo,
    canShowPlayScore: canShowPlayScore,
    initPlayScore: initPlayScore,
    destroyPlayScore: destroyPlayScore,
    setPlayScorePlayState: setPlayScorePlayState,
    getStartRecordInfo: getStartRecordInfo,
    getEndRecordInfo: getEndRecordInfo,
    openReplay: openReplay,
    changePlayScoreLoading: changePlayScoreLoading,
    setIsRecordScoreing: setIsRecordScoreing
  };
};

exports.default = _default;